'use client';

import React, { useContext, useEffect } from 'react';
import { Button, ButtonProps } from '../Buttons';
import { FormContext } from './context';
interface FormHandlerProps {
  children: React.ReactNode;
  buttonProps: Omit<ButtonProps, 'onClick'>;
  formId?: string;
  onClick?: (e?: React.MouseEvent) => void;
}
export function FormButton({
  buttonProps = {
    theme: 'primary'
  },
  children,
  formId = 'd11809ca-540c-4d9a-b0c7-78a7bfd163e0',
  onClick
}: FormHandlerProps) {
  const {
    openForm,
    createForm
  } = useContext(FormContext);
  useEffect(() => {
    if (createForm) {
      createForm(formId);
    }
  }, [createForm, formId]);
  const open = (e: React.MouseEvent) => {
    e.stopPropagation();
    openForm ? openForm(formId) : null;
    onClick && onClick(e);
  };
  return <Button {...buttonProps} onClick={open}>
      {children}
    </Button>;
}